export const discountOffer = [
    {
        service: "Kucie młotem wyburzeniowym",
        price: 30, 
        discount: 35
      },
      {
        service: "Kucie młotem wyburzeniowym",
        price: 50, 
        discount: 60 
      },
      {
        service: "Kucie młotem wyburzeniowym",
        price: 70, 
        discount: 80 
      },
      {
        service: "Kucie młotem wyburzeniowym",
        price: 100, 
        discount: 120 
      },
      {
        service: "Roboty ziemne/rozładunki/inne",
        price: 20, 
        discount: 25
      },
      {
        service: "Roboty ziemne/rozładunki/inne",
        price: 30, 
        discount: 50 
      },
      {
        service: "Roboty ziemne/rozładunki/inne",
        price: 60, 
        discount: 70 
      },
      {
        service: "Roboty ziemne/rozładunki/inne",
        price: 90, 
        discount: 100
      },
]

export const MoneyExchangeOffer = [
  {
    price: 30, 
    amount: 35
  },
  {
    price: 50, 
    amount: 60 
  },
  {
    price: 70, 
    amount: 80 
  },
  {
    price: 100, 
    amount: 120 
  },
 
]